<template lang="pug">
  SspLayout(area="tnt")
    .row
      .col-md-12
        SspSaveForm(@onSubmit="save" :saving="saving" :saveDisabled="!isValid")
          .form-horizontal
            .form-group
              label.col-md-4.control-label Origin shipping location
              .col-md-8
                LocationPicker.origin-location(v-model="shipment.originLocation")
            .form-group
              label.col-md-4.control-label Target shipping location
              .col-md-8
                LocationPicker.target-location(v-model="shipment.targetLocation")
            .form-group
              label.col-md-4.control-label External Reference
              .col-md-8
                input.external-reference.form-control(type="text" v-model="shipment.externalReference")
            .form-group
              label.col-md-4.control-label Notes
              .col-md-8
                textarea.notes.form-control(v-model="shipment.notes")
            .form-group
              label.col-md-4.control-label Free picking
              .col-md-8
                input.free-picking(type="checkbox" v-model="shipment.freePicking")
            .form-group
              label.col-md-4.control-label Expected Delivery Date
              .col-md-8
                Datepicker.expected-delivery-date(v-model="shipment.expectedDeliveryDate" :timePicker="true" placeholder="Select a date")
                transition(name="fade")
</template>

<script>
import miniToastr from 'mini-toastr'
import TrackNTrace from '@/service/apis/TrackNTrace'
import LocationPicker from '@/components/ssp/LocationPicker'
import Datepicker from '@/components/common/Datepicker'
import { dateFilter } from '@/filters/filters'

export default {
  data: () => ({
    saving: false,
    shipment: {
      originLocation: null,
      targetLocation: null,
      externalReference: null,
      notes: null,
      freePicking: null,
      expectedDeliveryDate: null
    }
  }),
  created() {
    if (this.shipmentId) {
      TrackNTrace.getShipment(this.shipmentId)
        .then((resp) => {
          this.shipment = resp.data.shipment
        })
        .catch((e) => { this.$emit('error', e) })
    }
  },
  methods: {
    save() {
      this.saving = true
      const shipment = {}

      shipment.originLocation = { id: this.shipment.originLocation.id }
      shipment.targetLocation = { id: this.shipment.targetLocation.id }
      shipment.freePicking = this.shipment.freePicking
      shipment.notes = this.shipment.notes
      shipment.externalReference = this.shipment.externalReference
      shipment.expectedDeliveryDate = new Date(this.shipment.expectedDeliveryDate)

      const call = this.shipmentId ? TrackNTrace.updateShipment(this.shipmentId, shipment) : TrackNTrace.createShipment(shipment)
      const action = this.shipmentId ? 'updated' : 'created'
      call
        .then(() => {
          miniToastr.success(`Shipment successfully ${action}`)
          this.$router.push(this.shipmentId ? { name: 'shipment', params: { id: this.shipmentId } } : { name: 'listShipments' })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    }
  },
  computed: {
    shipmentId() {
      return parseInt(this.$route.params.id, 10)
    },
    isValid() {
      return this.shipment.originLocation && this.shipment.targetLocation
    }
  },
  components: {
    LocationPicker,
    Datepicker
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/shipments/EditShipment.vue